import React, { useEffect, useState } from 'react';
import { Button, Card, FileUploadCards, Input, Upload, UploadLbis } from 'ui';
import { useIntl } from 'react-intl';
import { message } from 'antd';
import FileUploadPart from './components/FileUploadPart';
import { useSearchParams } from 'react-router-dom';
import { SubmittableAttachmentProps } from '../index';

export interface FileProp {
  id: number;
  name: string;
  size: number;
  uid: string;
}

interface UploadFileProps {
  files: any[] | [];
  setFiles: Function;
  submittableAttachments: SubmittableAttachmentProps[];
}

const UploadFiles = ({ files, setFiles, submittableAttachments }: UploadFileProps) => {
  const intl = useIntl();
  const [searchParams] = useSearchParams();
  const isMlNull = searchParams.get('ml') == null;
  const onMunicipalityLand = searchParams.get('ml') === 't';
  const isThereProjectId = searchParams.get('project-id') && !!searchParams.get('project-id');
  const projectId = isThereProjectId ? searchParams.get('project-id') : undefined;
  const [confirmationFiles, setConfirmationFiles] = useState<any[]>([]);
  const [restOfFiles, setRestOfFiles] = useState<any>([]);
  const [additionalFiles, setAdditionalFiles] = useState<any[]>([]);
  const isMunicipalLand = files.some(
    (file: any) => file.section_name == 'Zemes īpašnieka saskaņojums, ka piekrīt projekta realizācijai uz viņa zemes'
  );

  useEffect(() => {
    setRestOfFiles([
      ...files.filter(
        (file) =>
          file.section_name !== 'Papildus' &&
          file.section_name !== 'Zemes īpašnieka saskaņojums, ka piekrīt projekta realizācijai uz viņa zemes'
      ),
    ]);
    setAdditionalFiles([...files.filter((file) => file.section_name === 'Papildus')]);
    setConfirmationFiles([
      ...files.filter(
        (file) => file.section_name === 'Zemes īpašnieka saskaņojums, ka piekrīt projekta realizācijai uz viņa zemes'
      ),
    ]);
  }, [files]);

  const addFile = async (fileList: FileProp[], newFile: any, section_name: string) => {
    const isFileAvailable = fileList.find((file: any) => file.name === newFile.file.name);
    if (isFileAvailable) {
      message.warning(intl.formatMessage({ id: 'submit_project.such_file_uploaded' }));
      return;
    }
    const id = Date.now();
    const res = newFile.file.originFileObj;
    setFiles([...files, { data: res, filename: newFile.file?.name, id, section_name, size: newFile.file?.size }]);
  };

  const removeFile = (removingFile: any) => {
    if (removingFile.blob) {
      setFiles((prev: { [key: string]: any }[]) =>
        prev.map((file) => {
          if (file.id === removingFile.id) {
            return { ...file, _destroy: true };
          } else {
            return file;
          }
        })
      );
    } else {
      setFiles([...files.filter((file) => file.id != removingFile.id)]);
    }
  };

  return (
    <>
      <ol className="upload-list">
        {((projectId && isMunicipalLand) || (!isMlNull && !onMunicipalityLand)) && (
          <li key="static_key">
            <FileUploadPart
              title={intl.formatMessage({ id: `participation_budget.coniform_landowner_project_his_hand` })}
              onChange={(info: any) =>
                addFile(
                  confirmationFiles,
                  info,
                  'Zemes īpašnieka saskaņojums, ka piekrīt projekta realizācijai uz viņa zemes'
                )
              }
              fileCount={
                confirmationFiles.filter(
                  (file: any) =>
                    file.section_name === 'Zemes īpašnieka saskaņojums, ka piekrīt projekta realizācijai uz viņa zemes'
                ).length
              }
              isRequired
            />
            <FileUploadCards
              fileList={confirmationFiles}
              handleRemove={(file: any) => removeFile(file)}
              submitAttachment={{ name: 'Zemes īpašnieka saskaņojums, ka piekrīt projekta realizācijai uz viņa zemes' }}
            />
          </li>
        )}
        {submittableAttachments?.map((submitAttachment, index) => (
          <li
            key={`submittable_${index}`}
            value={index + 1 + ((projectId && isMunicipalLand) || (!isMlNull && !onMunicipalityLand) ? 1 : 0)}
          >
            <FileUploadPart
              title={submitAttachment.name}
              isRequired={submitAttachment.is_required}
              fileCount={restOfFiles.filter((file: any) => file.section_name === submitAttachment.name).length}
              onChange={(info: any) =>
                addFile(
                  restOfFiles.filter((file: any) => file.section_name === submitAttachment.name),
                  info,
                  submitAttachment.name
                )
              }
            />
            <FileUploadCards
              fileList={restOfFiles.filter((file: any) => file.section_name === submitAttachment.name)}
              handleRemove={(file: any) => removeFile(file)}
              submitAttachment={submitAttachment}
            />
          </li>
        ))}
        {additionalFiles.length > 0
          ? additionalFiles.map((file, index) => {
              if (file._destroy) return <></>;

              return (
                <li key={`additional_${index}`}>
                  <Input
                    name={['custom_name', file.section_name, `${file.id}`]}
                    validations="required"
                    size="middle"
                    className="one-row-item"
                    placeholder={intl.formatMessage({ id: 'general.name' })}
                  />

                  <Card key={file.name} className="uploaded_file">
                    <p>
                      <div className="filename">{file.blob ? file.blob.filename : file.filename}</div>
                      <span>{((file.blob ? file.blob.byte_size : file.data.size) / (1024 * 1024)).toFixed(2)} MB</span>
                    </p>
                    <i className="fa-solid fa-xmark remove_btn" onClick={() => removeFile(file)}></i>
                  </Card>
                </li>
              );
            })
          : null}
        <li>
          <div className="upload">
            <div className="upload_btn">
              <UploadLbis
                geoClassifer={true}
                action={() => ''}
                fileList={[]}
                showUploadList={false}
                onChange={(info) => addFile(additionalFiles, info, 'Papildus')}
              >
                <span>{intl.formatMessage({ id: 'participation_budget.upload_additional_file' })}</span>
              </UploadLbis>
            </div>
          </div>
        </li>
      </ol>
    </>
  );
};

export default UploadFiles;
